module.exports = __webpack_public_path__ + "static/media/dry-tap-getty.5e7d89a2.jpg";